import React from "react";

import { FieldStatic } from "2g-form";
import { PlaceholderText } from "2g-placeholder";
import PageMessage from "2g-page-message";

import useMessages from "./i18n/useMessages";
import useRezervaceVytvoreniFixniNaroky from "./hooks/useRezervaceVytvoreniFixniNaroky";

export function RezervaceVytvoreniFixniNaroky() {
  const { fixniNarokyLabel, fixniNarokyText } = useMessages();
  const { visible, loading, data, error } = useRezervaceVytvoreniFixniNaroky();

  return visible ? (
    <FieldStatic label={fixniNarokyLabel()}>
      {loading ? (
        <PlaceholderText>
          {fixniNarokyText({ zadane: 1, povolene: 8 })}
        </PlaceholderText>
      ) : error ? (
        <PageMessage type="default" inline>
          {error}
        </PageMessage>
      ) : (
        fixniNarokyText(data)
      )}
    </FieldStatic>
  ) : undefined;
}

RezervaceVytvoreniFixniNaroky.propTypes = {};

export default React.memo(RezervaceVytvoreniFixniNaroky);
